if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.cartPopap = function() {
    jQuery.ajax({
      url: '/cart/?view=popup',
      dataType: 'html',
      type: 'GET',
      success: function(data) {
        // Open directly via API
        jQuery.magnificPopup.open({
          items: {
            src: '<div class="mfp-with-anim g-popup-quick-view" id="g-content-cart-popup">' + data + '</div>',
            type: 'inline'
          },
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-move-horizontal';
            },
            close: function() {
              jQuery( '#g-content-cart-popup' ).empty();
            }
          },
        });
      },
      error: function() {
        console.log('Quick view error');
      },
    });
}

Shopify.addItem = function(variant_id, quantity, callback, attr) {

  var quantity = quantity || 0;
  if(typeof attr == 'undefined'){
    attr = [];
  }
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {quantity: quantity, id:variant_id,properties: attr},
    dataType: 'json',
    success: function(line_item) {

      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
       jQuery.get('/cart?view=json', function(data) {
         /*optional stuff to do after success */
        jQuery('.block-cart-list').html(data);
       });
       jQuery.getJSON('/cart.js', function(cart) {
          jQuery(".la-cart-count").html(cart.item_count);
        } );
      }
      
      	Shopify.cartPopap();
      
      
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    beforeSend : function (){
       jQuery(".block-cart-list").addClass('removing-process');
   },
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) { 
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        jQuery.get('/cart?view=json', function(data) {
         /*optional stuff to do after success */
        jQuery('.block-cart-list').html(data);
       });
       jQuery.getJSON('/cart.js', function(cart) {
          jQuery(".la-cart-count").html(cart.item_count);
        });
      }
    },
    complete: function() {
      jQuery(".block-cart-list").removeClass('removing-process');
    },
    error: function(XMLHttpRequest, textStatus) {
      jQuery(".block-cart-list").removeClass('removing-process');
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

jQuery(document).ready(function($) {
    $(document).on("click", ".ajax_form_cart", function(e) {
      e.preventDefault();
      var t = $(this);
      $(this).attr("disabled", "disabled").css("pointer-events", "none").addClass("loading"), $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: t.closest("form").serialize(),
        dataType: "json",
        success: function(e) {
          $.get("/cart?view=json", function(e) {
            $(".block-cart-list").html(e)
          }), $.getJSON("/cart.js", function(e) {
           $(".la-cart-count").html(e.item_count);
          })
          $('a.lightcase-icon-close').trigger('click');
          
          	Shopify.cartPopap();
          
          
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        },
        complete: function() {
          t.removeAttr("disabled").css("pointer-events", "auto").removeClass("loading")
        }
      })
    })
});